import styled from 'styled-components';

export const FormStack = styled.form`
   display: grid;
   gap: 16px;
   max-width: 420px;
`;

// Aviso PRÉ-submit: o usuário precisa saber que vai ser desconectado de todos
// os dispositivos ANTES de trocar a senha, não depois (0097 §7).
export const WarningNote = styled.div`
   display: flex;
   gap: 10px;
   align-items: flex-start;

   padding: 12px 14px;
   margin-bottom: 18px;
   max-width: 420px;

   font-size: 13px;
   line-height: 1.5;
   color: ${({ theme }) => theme.colors.textPrimary};

   background: rgba(240, 173, 78, 0.1);
   border: 1px solid rgba(240, 173, 78, 0.45);
   border-radius: 10px;
`;

export const WarningIcon = styled.span`
   font-size: 15px;
   line-height: 1.35;
`;

export const FormActions = styled.div`
   display: flex;
   gap: 10px;
   justify-content: flex-end;
   max-width: 420px;
   margin-top: 4px;
`;
